'use strict';

//Utility
import React from 'react';

//Components
import SectionHeader from '../Common/SectionHeader.jsx';
import RadioInput from '../Common/RadioInput.jsx';
//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
//Store
import AdviserAttestationStore from '../../stores/AdviserAttestationStore.js';
//Action
import AdviserAttestationActions from '../../actions/AdviserAttestationActions.js';

function getStateFromStores() {
    return {
        model: AdviserAttestationStore.getAdviserAttestationModel(),
        errorList: AdviserAttestationStore.getErrorList()
    };
}

var AdviserAttestationSection = React.createClass({
    getInitialState: function() {
        return getStateFromStores();
    },
    componentDidMount: function() {
        AdviserAttestationStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function() {
        AdviserAttestationStore.removeChangeListener(this._onChange);
    },

    _onChange: function() {
        this.setState(getStateFromStores());
    },

    updateAndSendAdviserAttestationModel: function(e) {
        AdviserAttestationActions.updateAdviserAttestationModel(e.target.model, e.target.value);
    },

    render: function() {
        var onlineAttestationContent = (this.props.content) ? this.props.content.adviserAttestation : {}; 

        return (
            <div className="adviserAttestationSection" id="adviserAttestationSection">
                <SectionHeader focus={this.props.focus} sectionName={onlineAttestationContent.sectionHeader} />
                <section className="container">
                    <RadioInput id="adviserAttestationSection"
        data={ApplicationConstants.YesNoRadioData}
        value={this.state.model.attestation}
        label={onlineAttestationContent.sectionText}
        model="attestation"
        onChange={this.updateAndSendAdviserAttestationModel}
        contextualMessage={onlineAttestationContent.adviserAttesttationNote}
        errorList={this.state.errorList} />
</section>
</div>
        );
    }
});

module.exports = AdviserAttestationSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AdviserAttestation/AdviserAttestationSection.jsx